import axios from "axios";

export class HttpService {
  static options = { withCredentials: true };

  static get(url: string) {
    return axios.get(url, this.options);
  }
  static delete(url: string) {
    return axios.delete(url, this.options);
  }

  static post(url: string, data: any) {
    return axios.post(url, data, this.options);
  }
  static put(url: string, data: any) {
    return axios.put(url, data, this.options);
  }
}
